var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 6.66663C10.9997 5.99996 12.9997 2.66663 12.9997 2.66663H19.6663C19.6663 2.66663 21.6663 6.13329 24.333 6.66663L28.333 20.6666H22.9997V29.3333H9.66634V20.6666H4.33301L8.33301 6.66663Z",
    fill: "#F4D5C0",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 3L16.3324 12.3333L19.6657 3",
    fill: "#F7F3EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 3L16.3324 12.3333L19.6657 3",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 12V29.3333",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoat);
export default __webpack_public_path__ + "static/media/Coat.099fcf71cfd84e2cd7946ae376e8dc70.svg";
export { ForwardRef as ReactComponent };